import React from 'react';
import { VendorSolutionProvider } from '../vendor-solution-provider';
import VendorSolutionToolContainer from './vendor-solution-tool-container';

const VendorSolutionTool = props => {

  return (
    <VendorSolutionProvider>
      <VendorSolutionToolContainer {...props} />
    </VendorSolutionProvider>
  );
};

export default VendorSolutionTool;
